import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {SetupGuideTask, SetupGuideTaskProps} from '../common/setupGuideTask';

/*
 * Constants.
 */

const accountCustomFieldsUrl = '/settings/global/custom-fields/accounts/overview';

/*
 * Props.
 */

type AddAccountCustomFieldTaskProps = Omit<SetupGuideTaskProps, 'label' | 'onClick'> & {
  isUserGlobalAdmin: boolean;
  navigateToLink: HandlerOf<string>;
};

/*
 * Styles.
 */

const StyledTooltipDiv = styled.div`
  max-width: 220px;
`;

/*
 * Component.
 */

export const AddAccountCustomFieldTask: FC<AddAccountCustomFieldTaskProps> = ({
  isUserGlobalAdmin,
  isComplete,
  navigateToLink,
}) => (
  <SetupGuideTask
    label={<Trans id="accounts-setup-guide-task-add-account-custom-field">Add an account field</Trans>}
    isComplete={isComplete}
    onClick={() => navigateToLink(accountCustomFieldsUrl)}
    renderDisabledTooltip={isUserGlobalAdmin ? undefined : renderDisabledTooltip}
  />
);

/*
 * Helpers.
 */

function renderDisabledTooltip() {
  return (
    <StyledTooltipDiv>
      <Trans id="accounts-setup-guide-task-add-account-custom-field-disabled">
        You don&apos;t have access to custom fields, please reach out to your Company admin
      </Trans>
    </StyledTooltipDiv>
  );
}
